import FeatureController from '../FeatureController';
import {forEach} from "underscore";

export default class SearchController extends FeatureController
{
  constructor(panel, $state) {
    super(panel, $state);
    this.endpoint = '/v1/matches/search';
    this.hasSearched = false;
    this.initSearch();
    let search_criteria = localStorage.getItem('search_criteria');
    if (search_criteria) {
      this.search_criteria = JSON.parse(search_criteria);
    } else {
      this.search_criteria = {'sort': 'distance', 'photos':'both', 'distance':'unlimited'};
    }

    // const self = this;
    //
    // this.refine = {};
    //
    // this.search();
    //
    // this.popup = {
    //   photos (person) {
    //     self.panel.get('/v1/popup?p=inline-photo', function (response) {
    //       self._photo = person;
    //       //   self.panel.popup_init(response, $scope);
    //     });
    //   }
    // }
  }

  editSearchParameters () {
      this.preferenceModal = this.panel.popupModal($('#edit-search-preferences'));
  }

  refine_matches (params) {
      let url = this.endpoint;
      let get_params = {sort: this.refine.sort, photos: this.refine.photos};
      let request = '?';
      if(params){
          get_params = $.extend(get_params, params);
      }

      for(let i in get_params){
          request = request+i+'='+get_params[i]+'&';
      }
      let searchUrl=url+request;
      const self = this;
      this.panel.get(searchUrl, (response) => {
          if(self.panel.okay(response)) {
              self.setSearchResults(response.data);
          }
      });
  }

  // search () {
  //     const self = this;
  //     this.panel.get(this.endpoint, (response) => {
  //         if(self.panel.okay(response)) {
  //             self.setSearchResults(response.data);
  //         }
  //     });
  // }
  //
  // setSearchResults (data) {
  //     this.current_page = data.current_page;
  //     this.matches = data.matches;
  //     this.options = data.options;
  //     this.per_page = data.per_page;
  //     this.preferences = data.preferences;
  //     this.total = data.total;
  //     this.refine.sort = this.panel.getParam('sort') || 'distance';
  //     this.refine.photos = this.panel.getParam('photos') || 'both';
  //     this.pages = Math.ceil(this.total/this.per_page);
  //     this.next_page = this.current_page < this.pages ?  parseInt(this.current_page)+1 : false;
  //     this.prev_page = this.current_page > 1 ?  parseInt(this.current_page)-1 : false ;
  // }

  fetch_page(page){this.refine_matches({page:page});};

  fetch_next(){this.refine_matches({page:this.next_page});};

  fetch_prev() {this.refine_matches({page:this.prev_page});};

  get_checked_match (k, v) {
    return this.search_preferences[k] && this.search_preferences[k].indexOf(v+"") > -1;
  }

  push_match (k, v) {
    let match = [];
    if (this.search_preferences[k]) {
      match = this.search_preferences[k].split(',');
    }
    match.indexOf(v) > -1 && match.splice(match.indexOf(v),1) || match.push(v);
    this.search_preferences[k] = match.join(",");
  }

  cache_message(){};

  _im_(){

      let _im_ = {recipient:match.register_id, message:match.instant_message};

      this.panel.post('/v1/matches/quick_message', _im_, function(response){

          if(this.panel.okay(response)){

              match.instant_message = '';
          }
      });
  }

  edit_preferences (edit) {

      const self = this;

      let callback = function(){

          if(!self.panel.isMobile()) return;

          $('.option-title').each(function(){

              $(this).click(function(){

                  let options = $(this).siblings('.option-items');

                  if(!options.hasClass('alive')){ options.addClass('alive'); options.css({display:'block'});}

                  else{ options.removeClass('alive'); options.css({display:'none'});}
              });
          });
      };

      if(edit){
          $('.popup-preferences').removeClass('hide');
          callback();
      }
      else{
          $('.popup-cancel').click();
          $('.popup-preferences').addClass('hide');
      }
  }

  update_matches () {

      let data = {};

    localStorage.setItem('search_criteria', JSON.stringify(this.search_criteria));
      data.status = this.search_preferences.status;
      data.min_height = this.search_preferences.min_height;
      data.max_height = this.search_preferences.max_height;
      data.min_age = this.search_preferences.min_age;
      data.max_age = this.search_preferences.max_age;

      for (let i in this.options) {
          if (this.search_preferences[i]) {
            data[i] = this.search_preferences[i];
          }
      }

      const self = this;

      this.panel.post('/v1/search/update/preferences', {preferences:data}, (response) => {
        self.preferenceModal.close();
        if (self.panel.okay(response)) {
          self.isInlineSearch = true;
          self.setCurrentPage(1);
          self.search();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/features/search/SearchController.js